import {FormError} from './FormError.js'

export class CaptchaStatusNotActiveFormError extends FormError {}
